import React from 'react';

const AsyncRSSPage = React.lazy(() => import('./RSSContainer'));

export const RSSPage = () => {
  return <AsyncRSSPage />;
};
